/* unplugin-vue-components disabled */import script from "./menu.vue?vue&type=script&setup=true&lang=js"
export * from "./menu.vue?vue&type=script&setup=true&lang=js"

import "./menu.vue?vue&type=style&index=0&id=40c93446&scoped=true&lang=css"
import "./menu.vue?vue&type=style&index=1&id=40c93446&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c93446"]])

export default __exports__